export type TaskProgressDetail = {
	done?: number
	phase?: string
	phaseDetail?: string
	progress?: number
	total?: number
}

export const runningPercent = (progress?: number, detail?: TaskProgressDetail) => {
	if (typeof detail?.progress === 'number') return detail.progress
	if (typeof progress === 'number') return progress
	if (detail?.total) return Math.round(((detail.done ?? 0) / detail.total) * 100)
	return 0
}

export const runningDescription = (waitText: string, detail?: TaskProgressDetail) => {
	if (!detail) return waitText
	const phase = [detail.phase, detail.phaseDetail].filter(Boolean).join(' — ')
	const count = detail.total != null ? `${detail.done ?? 0}/${detail.total}` : ''
	return [waitText, phase, count].filter(Boolean).join(' · ')
}
